export default {"src":"/_next/static/media/discord.a3e94750.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};